import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Sidebar } from '../../shared/sidebar/sidebar';
import { SettingsService, PaymentMethodConfig } from '../../core/services/settings.service';

@Component({
  selector: 'app-settings',
  imports: [CommonModule, FormsModule, Sidebar],
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
})
export class SettingsPage implements OnInit {
  paymentMethods: PaymentMethodConfig[] = [];
  isLoading = true;
  isSaving: { [id: string]: boolean } = {};
  successMessage = '';
  errorMessage = '';

  constructor(private settingsService: SettingsService) {}

  ngOnInit() {
    this.loadPaymentMethods();
  }

  loadPaymentMethods() {
    this.isLoading = true;
    this.settingsService.getPaymentMethods().subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.paymentMethods = res.data;
        }
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Failed to load payment methods';
        this.isLoading = false;
      }
    });
  }

  saveMethod(method: PaymentMethodConfig) {
    this.isSaving[method.id] = true;
    this.successMessage = '';
    this.errorMessage = '';

    this.settingsService.updatePaymentMethod(method.id, {
      isActive: method.isActive,
      accountLink: method.accountLink
    }).subscribe({
      next: (res) => {
        this.isSaving[method.id] = false;
        if (res.success) {
          this.successMessage = `${method.name} updated successfully.`;
          setTimeout(() => this.successMessage = '', 3000);
        } else {
          this.errorMessage = res.message || 'Failed to update';
        }
      },
      error: () => {
        this.isSaving[method.id] = false;
        this.errorMessage = 'Failed to update payment method';
      }
    });
  }
}
